import { createContext } from "react";

export const DatagridFitContentContext = createContext(false);
